const storage = {
    getLocalStorage: (key: string) => {
        return JSON.parse(window.localStorage.getItem(key) as string)
    },
    setLocalStorage: (key: string, value: string) => {
        window.localStorage.setItem(key, value)
    },
    clearLocalStorage: () => {
        window.localStorage.clear()
    },
}
export default storage
